export default "__VITE_ASSET__4O3ZB5MK__"